
const __nuxt_page_meta = null
export default __nuxt_page_meta
